module.exports = __webpack_public_path__ + "img/cleandex_calls-icon.96a4faaf.svg";